export const UserExceptionType = {
    NoException: "NoException",
    Managers: "Managers",
    SelectedUsers: "SelectedUsers",
}


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/constants.js